exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "div.content[data-v-dcc76b4a]{margin-bottom:80px}.fade-enter-active[data-v-dcc76b4a],.fade-leave-active[data-v-dcc76b4a]{transition:opacity .1s}.fade-enter[data-v-dcc76b4a],.fade-leave-to[data-v-dcc76b4a]{opacity:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-dcc76b4a","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?data=@import "./src/scss/base";!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/js/components/engagement/EngagementContent.vue
// module id = 447
// module chunks = 1